import React, { useState } from 'react';
import '../styles/RightSidebar.css';
import { baseUrl } from '../config';



// Import icons from a library like FontAwesome
import { FaClosedCaptioning, FaMusic, FaAdjust, FaFilter, FaMagic, FaPalette, FaTachometerAlt, FaRandom } from 'react-icons/fa';

const RightSidebar = () => {
  const [expandedOption, setExpandedOption] = useState(null); // State to track expanded option

  // Handles expand and collapse for each option
  const handleExpand = (option) => {
    // Toggle the expanded option, if the same option is clicked, it will collapse
    setExpandedOption(expandedOption === option ? null : option);
  };

  return (
    <div className="right-sidebar">
      {/* Captions Option */}
      <div className={`sidebar-item ${expandedOption === 'captions' ? 'expanded' : ''}`} onClick={() => handleExpand('captions')}>
        <FaClosedCaptioning className="icon" />
        {expandedOption === 'captions' && (
          <div className="expanded-content">
            <h4>Captions</h4>
            <button>Add Captions</button>
            <button>Style Captions</button>
          </div>
        )}
      </div>

      {/* Audio Option */}
      <div className={`sidebar-item ${expandedOption === 'audio' ? 'expanded' : ''}`} onClick={() => handleExpand('audio')}>
        <FaMusic className="icon" />
        {expandedOption === 'audio' && (
          <div className="expanded-content">
            <h4>Audio</h4>
            <input type="range" min="0" max="100" className="volume-slider" />
            <button>Detach Audio</button>
          </div>
        )}
      </div>

      {/* Fade Option */}
      <div className={`sidebar-item ${expandedOption === 'fade' ? 'expanded' : ''}`} onClick={() => handleExpand('fade')}>
        <FaAdjust className="icon" />
        {expandedOption === 'fade' && (
          <div className="expanded-content">
            <h4>Fade</h4>
            <input type="range" min="0" max="100" className="fade-slider" />
            <button>Fade In</button>
            <button>Fade Out</button>
          </div>
        )}
      </div>

      {/* Filters Option */}
      <div className={`sidebar-item ${expandedOption === 'filters' ? 'expanded' : ''}`} onClick={() => handleExpand('filters')}>
        <FaFilter className="icon" />
        {expandedOption === 'filters' && (
          <div className="expanded-content">
            <h4>Filters</h4>
            <button>Filter 1</button>
            <button>Filter 2</button>
            <button>Filter 3</button>
          </div>
        )}
      </div>

      {/* Effects Option */}
      <div className={`sidebar-item ${expandedOption === 'effects' ? 'expanded' : ''}`} onClick={() => handleExpand('effects')}>
        <FaMagic className="icon" />
        {expandedOption === 'effects' && (
          <div className="expanded-content">
            <h4>Effects</h4>
            <button>Effect 1</button>
            <button>Effect 2</button>
          </div>
        )}
      </div>

      {/* Adjust Colors Option */}
      <div className={`sidebar-item ${expandedOption === 'adjustColors' ? 'expanded' : ''}`} onClick={() => handleExpand('adjustColors')}>
        <FaPalette className="icon" />
        {expandedOption === 'adjustColors' && (
          <div className="expanded-content">
            <h4>Adjust Colors</h4>
            <label>Brightness</label>
            <input type="range" min="0" max="100" />
            <label>Contrast</label>
            <input type="range" min="0" max="100" />
          </div>
        )}
      </div>

      {/* Speed Option */}
      <div className={`sidebar-item ${expandedOption === 'speed' ? 'expanded' : ''}`} onClick={() => handleExpand('speed')}>
        <FaTachometerAlt className="icon" />
        {expandedOption === 'speed' && (
          <div className="expanded-content">
            <h4>Speed</h4>
            <button>0.5x</button>
            <button>1x</button>
            <button>2x</button>
          </div>
        )}
      </div>

      {/* Transition Option */}
      <div className={`sidebar-item ${expandedOption === 'transition' ? 'expanded' : ''}`} onClick={() => handleExpand('transition')}>
        <FaRandom className="icon" />
        {expandedOption === 'transition' && (
          <div className="expanded-content">
            <h4>Transitions</h4>
            <button>Transition 1</button>
            <button>Transition 2</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RightSidebar;

